import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { MultiLanguageMessageService } from 'src/app/core/services/multi-language-message/multi-language-message.service';

@Component({
  selector: 'app-cookie-notice',
  templateUrl: './cookie-notice.component.html',
  styleUrls: ['./cookie-notice.component.scss'],
})
export class CookieNoticeComponent implements OnInit {
  template: string;

  /**
   * コンストラクター関数
   * @param http Angular Http クライアント
   * @param multiLanguageMessageService 多言語対応サービス
   */
  /**
   * Constructor function
   * @param http Angular Http Client
   * @param multiLanguageMessageService Multilingual service
   */
  constructor(
    private http: HttpClient,
    private multiLanguageMessageService: MultiLanguageMessageService,
  ) {}

  /**
   * Angular Life Cycle Method
   */
  ngOnInit() {
    // Assets から外部ファイルを取得
    // Grab HTML external file from assets
    this.http
      .get(this.multiLanguageMessageService.dictionary('sidCookieNoticeTemplate'), {
        responseType: 'text',
      })
      .subscribe(
        (template: string) => (this.template = template),
        () => (this.template = this.multiLanguageMessageService.localeId),
      );
  }
}
